const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

module.exports = { API_BASE_URL }
